import { useState } from 'react';
import { TextInput, Button, Paper, Stack, Title, Text, Alert } from '@mantine/core';
import { IconMail, IconCheck, IconAlertCircle } from '@tabler/icons-react';

const cfg = window.astSupportConfig || {};

export default function MagicLinkForm({ embedded = false }) {
    const [email, setEmail] = useState('');
    const [sending, setSending] = useState(false);
    const [sent, setSent] = useState(false);
    const [error, setError] = useState(null);

    async function submit(e) {
        e.preventDefault();
        if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
            setError('Vul een geldig e-mailadres in.');
            return;
        }
        setSending(true);
        setError(null);
        try {
            const res = await fetch(`${cfg.apiUrl}/support/request-link`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });
            if (!res.ok) {
                const body = await res.json().catch(() => ({}));
                throw new Error(body.message || `HTTP ${res.status}`);
            }
            setSent(true);
        } catch (err) {
            setError(err.message);
        } finally {
            setSending(false);
        }
    }

    const containerStyle = embedded
        ? { padding: '16px', flex: 1, overflowY: 'auto' }
        : { maxWidth: 480, margin: '64px auto', padding: '0 16px' };

    return (
        <div style={containerStyle}>
            <Paper withBorder={!embedded} p={embedded ? 'md' : 'xl'} radius="md">
                <Stack>
                    <div>
                        <Title order={2} mb={4}>{cfg.companyName || 'Support'}</Title>
                        <Text c="dimmed" size="sm">
                            Vul uw e-mailadres in om een login-link te ontvangen waarmee u toegang krijgt tot onze AI support-medewerker.
                        </Text>
                    </div>

                    {sent ? (
                        <Alert color="green" icon={<IconCheck size={20} />} title="Link verzonden">
                            Als <strong>{email}</strong> bij ons bekend is, ontvangt u binnen enkele minuten een e-mail met een login-link.
                            Deze is 24 uur geldig.
                        </Alert>
                    ) : (
                        <form onSubmit={submit}>
                            <Stack>
                                <TextInput
                                    label="E-mailadres"
                                    placeholder="u@bedrijf.nl"
                                    leftSection={<IconMail size={16} />}
                                    type="email"
                                    required
                                    value={email}
                                    onChange={(e) => setEmail(e.currentTarget.value)}
                                    autoFocus
                                />
                                {error && (
                                    <Alert color="red" icon={<IconAlertCircle size={16} />} variant="light">
                                        {error}
                                    </Alert>
                                )}
                                <Button type="submit" loading={sending} fullWidth>
                                    Stuur login-link
                                </Button>
                                <Text size="xs" c="dimmed" ta="center">
                                    Alleen klanten van {cfg.companyName || 'ons'} kunnen inloggen.
                                </Text>
                            </Stack>
                        </form>
                    )}
                </Stack>
            </Paper>
        </div>
    );
}
